import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { acceptInvite } from '@/api/membership';
import Loading from '@/components/UI/loading';
import type { AppDispatch } from '../../store';
import { SignOutUser } from '../../store/Auth';

const Invite = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const dispatch = useDispatch<AppDispatch>();

  useLayoutEffect(() => {
    const accept = async () => {
      if (token) {
        try {
          await acceptInvite(token);
          localStorage.setItem('invite-accepted', 'true');
        } catch (_err) {}
      }
      window.location.href = '/';
    };
    dispatch(SignOutUser());
    accept();
  }, [token, dispatch]);

  return <Loading loadingText='Loading' />;
};

export default Invite;
